// extracted by mini-css-extract-plugin
export default {"input":"EditMarkForm_input__a7Q5q","del":"EditMarkForm_del__s2RGb"};